//node-modules
import { useEffect, useRef, useState } from "react";
import { createSearchParams, Navigate, useLocation } from "react-router-dom";
import { config } from "../config/config";
import { validate as isUuid } from "uuid";

type urlProps = {
  path: string;
  children: any;
};

const AuthenticatedGurad = ({ path, children }: urlProps) => {
  const location = useLocation();

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isAuthenticated, setIsAuthenticate] = useState<boolean>(false);

  function getCookie(cname: string) {
    var name = cname + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i].trim();
      if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
  }

  useEffect(() => {
    const authFunc = async () => {
      setIsLoading(true);

      const login_auth = getCookie("login_auth");

      if (!login_auth) {
        const url = new URL(window.location.href);
        const urlPathname = url.pathname.substring(1);

        if (urlPathname && isUuid(urlPathname)) {
          // URL内にPJが存在する場合
          window.location.replace(
            `${config.serverHost}/login?type=web&projectId=${urlPathname}`
          );
        } else {
          // 上記以外
          const search = location.search;
          const params = new URLSearchParams(search);

          window.location.replace(
            `${config.serverHost}/login?type=web&${params.toString()}`
          );
        }
      } else {
        setIsAuthenticate(true);
        document.cookie =
          "login_auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      }

      setIsLoading(false);
    };

    authFunc();

    return () => {
      // sessionStorage.setItem("visited", "true");
      setIsLoading(true);
      setIsAuthenticate(false);
      document.cookie =
        "login_auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    };
  }, [location.pathname]);

  return isLoading ? <></> : isAuthenticated ? <>{children}</> : <></>;
};

export default AuthenticatedGurad;
